/**
 * section-product.js — PDP gallery (Splide), variants, ajax ATC, countdown, notify
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '{{ amount_no_decimals }}';
      return Shopify.formatMoney(cents, format);
    }
    var num = Math.round(cents / 100);
    var formatted = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
    }
    return formatted;
  }

  function getProductData(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var jsonEl = scope.querySelector('[data-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function collectZoomItems(gallery) {
    var items = [];
    var maxDimension = (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) ? 1200 : 1800;

    gallery.querySelectorAll('img[data-original-src]').forEach(function (img) {
      if (img.closest('.ci-product-gallery__featured')) return;

      var maxWidth = parseInt(img.getAttribute('data-max-width'), 10) || img.naturalWidth || 1200;
      var maxHeight = parseInt(img.getAttribute('data-max-height'), 10) || img.naturalHeight || 1800;
      var reduceFactor = 1;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1);
      }

      items.push({
        src: img.getAttribute('data-original-src'),
        w: Math.floor(maxWidth / reduceFactor),
        h: Math.floor(maxHeight / reduceFactor),
        msrc: img.currentSrc || img.src,
        el: img
      });
    });
    return items;
  }

  function updatePswpNav(pswp, pswpElement) {
    var prev = pswpElement.querySelector('.pswp__button--prev');
    var next = pswpElement.querySelector('.pswp__button--next');
    if (!prev || !next) return;

    var index = pswp.getCurrentIndex();
    var total = typeof pswp.options.getNumItemsFn === 'function'
      ? pswp.options.getNumItemsFn()
      : (pswp.items ? pswp.items.length : 0);

    if (index <= 0) {
      prev.setAttribute('disabled', 'disabled');
      prev.setAttribute('aria-hidden', 'true');
    } else {
      prev.removeAttribute('disabled');
      prev.removeAttribute('aria-hidden');
    }

    if (index >= total - 1) {
      next.setAttribute('disabled', 'disabled');
      next.setAttribute('aria-hidden', 'true');
    } else {
      next.removeAttribute('disabled');
      next.removeAttribute('aria-hidden');
    }
  }

  function openProductZoom(gallery, index) {
    if (!window.PhotoSwipe) return;

    var items = collectZoomItems(gallery);
    if (!items.length) return;

    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    var ui = pswpElement.querySelector('.pswp__ui');
    var startIndex = typeof index === 'number' ? index : 0;
    if (startIndex < 0 || startIndex >= items.length) startIndex = 0;

    // Prestige: PhotoSwipe(container, false, items, options) — custom UI, no default skin
    var pswp = new window.PhotoSwipe(pswpElement, false, items, {
      index: startIndex,
      history: false,
      focus: false,
      loop: false,
      showHideOpacity: true,
      showAnimationDuration: 500,
      closeOnVerticalDrag: false,
      allowPanToNext: false,
      pinchToClose: false,
      closeOnScroll: false,
      barsSize: { top: 0, bottom: 0 },
      spacing: 0,
      maxSpreadZoom: 2,
      getDoubleTapZoom: function (isMouseClick, item) {
        // Live Prestige uses 1.6 for mouse; slightly softer here
        if (isMouseClick) return 1.45;
        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
      },
      getThumbBoundsFn: function (i) {
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var thumb = items[i] && items[i].el;
        if (!thumb || !thumb.getBoundingClientRect) return { x: 0, y: 0, w: 0 };
        var rect = thumb.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    });

    pswp.listen('parseVerticalMargin', function (item) {
      item.vGap.top = 0;
      item.vGap.bottom = 0;
    });

    pswp.listen('beforeChange', function () {
      updatePswpNav(pswp, pswpElement);
    });

    pswp.listen('initialZoomIn', function () {
      if (ui) ui.classList.remove('pswp__ui--hidden');
    });

    pswp.listen('initialZoomOut', function () {
      if (ui) ui.classList.add('pswp__ui--hidden');
    });

    pswp.listen('doubleTap', function (point) {
      var initial = pswp.currItem.initialZoomLevel;
      if (pswp.getZoomLevel() !== initial) {
        pswp.zoomTo(initial, point, 333);
      } else {
        pswp.zoomTo(initial < 0.7 ? 1 : 1.33, point, 333);
      }
    });

    // Wire RoundButton controls (Prestige custom classes)
    function onUiClick(event) {
      var btn = event.target.closest('.pswp__button');
      if (!btn || btn.hasAttribute('disabled')) return;
      event.preventDefault();
      event.stopPropagation();
      if (btn.classList.contains('pswp__button--close')) pswp.close();
      else if (btn.classList.contains('pswp__button--prev')) pswp.prev();
      else if (btn.classList.contains('pswp__button--next')) pswp.next();
    }

    pswpElement.addEventListener('click', onUiClick);

    pswp.listen('destroy', function () {
      pswpElement.removeEventListener('click', onUiClick);
    });

    pswp.init();
    updatePswpNav(pswp, pswpElement);
  }

  function resolveZoomIndex(gallery, target) {
    if (!target) {
      var main = gallery._splideMain;
      if (main) {
        var activeSlide = gallery.querySelector('[data-ci-gallery-main] .splide__slide.is-active');
        if (activeSlide && activeSlide.hasAttribute('data-zoom-index')) {
          return parseInt(activeSlide.getAttribute('data-zoom-index'), 10) || 0;
        }
      }
      var first = gallery.querySelector('[data-zoom-index]');
      return first ? (parseInt(first.getAttribute('data-zoom-index'), 10) || 0) : 0;
    }

    var slide = target.closest('[data-zoom-index]');
    if (slide) return parseInt(slide.getAttribute('data-zoom-index'), 10) || 0;

    var img = target.closest('img[data-original-src]');
    if (img) {
      var items = collectZoomItems(gallery);
      for (var i = 0; i < items.length; i++) {
        if (items[i].el === img) return i;
      }
    }
    return 0;
  }

  function initZoom(gallery) {
    if (!gallery || gallery.getAttribute('data-enable-zoom') !== 'true') return;
    if (gallery._ciZoomBound) return;
    gallery._ciZoomBound = true;

    gallery.addEventListener('click', function (event) {
      var zoomBtn = event.target.closest('[data-action="open-product-zoom"]');
      if (zoomBtn) {
        event.preventDefault();
        openProductZoom(gallery, resolveZoomIndex(gallery, null));
        return;
      }

      // Desktop Prestige: click master image to open lightbox
      var img = event.target.closest('.ci-product-gallery__media img[data-original-src]');
      if (!img) return;
      if (img.closest('.ci-product-gallery__featured')) return;
      if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) return;

      event.preventDefault();
      openProductZoom(gallery, resolveZoomIndex(gallery, img));
    });
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-ci-product-gallery]');
    if (!gallery) return;

    var mainEl = gallery.querySelector('[data-ci-gallery-main]');
    var thumbsEl = gallery.querySelector('[data-ci-gallery-thumbs]');

    if (mainEl && window.Splide) {
      var slideCount = mainEl.querySelectorAll('.splide__slide').length;
      var main = new Splide(mainEl, {
        type: 'slide',
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: 0,
        pagination: false,
        arrows: false,
        speed: 400,
      });

      if (thumbsEl) {
        var thumbs = new Splide(thumbsEl, {
          fixedWidth: 70,
          isNavigation: true,
          gap: 0,
          rewind: true,
          pagination: false,
          arrows: false,
        });
        main.sync(thumbs);
        thumbs.mount();
      }

      main.on('mounted move', function () {
        syncGalleryPager(gallery, main);
      });

      initGalleryPager(gallery, main);

      main.mount();
      gallery._splideMain = main;

      var initial = parseInt(gallery.getAttribute('data-initial-index') || '0', 10);
      if (initial > 0) main.go(initial);
    }

    initZoom(gallery);
  }

  function syncGalleryPager(gallery, splide) {
    var pager = gallery.querySelector('[data-ci-gallery-pager]');
    var actions = gallery.querySelector('[data-ci-gallery-actions]');
    if (!pager && !actions) return;

    var index = typeof splide.index === 'number' ? splide.index : 0;
    var slideEl = gallery.querySelector('[data-ci-gallery-main] .splide__slide.is-active')
      || gallery.querySelector('[data-ci-gallery-main] .splide__slide');
    var mediaType = slideEl ? slideEl.getAttribute('data-media-type') : 'image';

    if (pager) {
      pager.querySelectorAll('[data-ci-gallery-dot]').forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-ci-gallery-dot'), 10);
        var isActive = dotIndex === index;
        dot.classList.toggle('is-selected', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    if (actions) {
      actions.classList.toggle('is-hidden', mediaType !== 'image');
    }
  }

  function initGalleryPager(gallery, splide) {
    var pager = gallery.querySelector('[data-ci-gallery-pager]');
    if (!pager || pager._ciPagerBound) return;
    pager._ciPagerBound = true;

    pager.querySelectorAll('[data-ci-gallery-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-ci-gallery-dot'), 10);
        if (!isNaN(index)) splide.go(index);
      });
    });

    var prevBtn = pager.querySelector('[data-ci-gallery-prev]');
    var nextBtn = pager.querySelector('[data-ci-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
  }

  function findVariant(product, options) {
    return product.variants.find(function (variant) {
      return variant.option1 === (options[0] || null)
        && variant.option2 === (options[1] || null)
        && variant.option3 === (options[2] || null);
    });
  }

  function getSelectedOptions(form) {
    var options = [];
    form.querySelectorAll('[data-option-position]').forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-option-position'), 10) - 1;
      if (el.type === 'radio') {
        if (el.checked) options[pos] = el.value;
      } else {
        options[pos] = el.value;
      }
    });
    return options;
  }

  function updateVariantUI(scope, variant) {
    if (!variant) return;

    // Update URL query parameter without page reload
    if (window.history && window.history.replaceState) {
      try {
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
      } catch (e) {}
    }

    var select = scope.querySelector('[data-ci-variant-select]');
    if (select) select.value = String(variant.id);

    var hiddenId = scope.querySelector('input[name="id"]');
    if (hiddenId) hiddenId.value = String(variant.id);

    // Update selected option labels in the form
    var form = scope.querySelector('[data-ci-product-form]');
    if (form) {
      form.querySelectorAll('.product-form__option, .ProductForm__Option').forEach(function (optEl) {
        var valSpan = optEl.querySelector('.product-form__selected-value, .ProductForm__SelectedValue');
        if (valSpan) {
          var checkedRadio = optEl.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            valSpan.textContent =
              checkedRadio.getAttribute('data-color-label') || checkedRadio.value;
          }
        }
      });
    }

    var priceEl = scope.querySelector('[data-ci-price]');
    var compareEl = scope.querySelector('[data-ci-compare-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    var btnPrice = scope.querySelector('[data-ci-btn-price]');
    if (btnPrice) btnPrice.textContent = formatMoney(variant.price);

    var skuEl = scope.querySelector('[data-ci-product-sku]');
    if (skuEl) skuEl.textContent = variant.sku || '';

    var submitBtn = scope.querySelector('[data-ci-add-to-cart]');
    if (submitBtn) {
      var textSpan = submitBtn.querySelector('span:first-child') || submitBtn;
      submitBtn.className = 'button button--full product-form__add-to-cart';
      submitBtn.setAttribute('data-ci-add-to-cart', '');

      if (!variant.available) {
        submitBtn.disabled = true;
        submitBtn.removeAttribute('data-action');
        submitBtn.classList.add('button--secondary');
        if (textSpan === submitBtn) {
          submitBtn.textContent = 'Sold out';
        } else {
          submitBtn.innerHTML = 'Sold out';
        }
      } else {
        submitBtn.disabled = false;
        submitBtn.setAttribute('data-action', 'add-to-cart');
        var showPayment = scope.getAttribute('data-show-payment-button') === 'true';
        submitBtn.classList.add(showPayment ? 'button--secondary' : 'button--primary');
        var isPreOrder = scope.getAttribute('data-template-suffix') === 'pre-order';
        var label = isPreOrder ? 'Pre-Order' : 'Add to cart';
        submitBtn.innerHTML = '<span>' + label + '</span>';
      }
    }

    var splideRoot = scope.querySelector('[data-ci-product-gallery]');
    if (splideRoot && splideRoot._splideMain && variant.featured_media) {
      var slides = splideRoot.querySelectorAll('[data-media-id]');
      slides.forEach(function (slide, index) {
        if (String(slide.getAttribute('data-media-id')) === String(variant.featured_media.id)) {
          splideRoot._splideMain.go(index);
        }
      });
    }

  }

  function initVariants(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var form = scope.querySelector('[data-ci-product-form]');
    if (!form) return;

    var data = getProductData(scope);
    if (!data || !data.product) return;

    function onChange() {
      var options = getSelectedOptions(form);
      var variant = findVariant(data.product, options);
      if (variant) updateVariantUI(scope, variant);
    }

    form.querySelectorAll('[data-option-position]').forEach(function (el) {
      el.addEventListener('change', onChange);
    });

    var variantSelect = form.querySelector('[data-ci-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var variant = data.product.variants.find(function (v) {
          return String(v.id) === String(variantSelect.value);
        });
        if (variant) updateVariantUI(scope, variant);
      });
    }

    form.querySelectorAll('.variant-ukuran').forEach(function (item) {
      item.addEventListener('click', function () {
        var radio = item.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        form.querySelectorAll('.variant-ukuran').forEach(function (i) {
          i.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
      });
    });

    onChange();
  }

  function initQuantity(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var form = scope.querySelector('[data-ci-product-form]');
    if (!form) return;
    var input = form.querySelector('[data-ci-qty-input]');
    if (!input) return;

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      if (action === 'increase-quantity' || action === 'decrease-quantity') {
        e.preventDefault();
        var val = parseInt(input.value, 10) || 1;
        if (action === 'increase-quantity') input.value = val + 1;
        if (action === 'decrease-quantity' && val > 1) input.value = val - 1;
      }
    });
  }

  function initAjaxAddToCart(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var form = scope.querySelector('[data-ci-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var submitBtn = form.querySelector('[data-ci-add-to-cart]');
      if (!submitBtn || submitBtn.disabled) return;

      e.preventDefault();
      submitBtn.disabled = true;
      var originalText = submitBtn.textContent;
      submitBtn.setAttribute('data-original-text', originalText);

      var formData = new FormData(form);

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (r) {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(function () {
          submitBtn.disabled = false;
          // Open after refresh completes — avoids race where preserve-closed
          // state closes the drawer that cart:open just opened.
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          );
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          if (err && typeof err.json === 'function') {
            err.json().then(function (data) {
              if (data && data.description) alert(data.description);
            });
          }
        });
    });
  }

  function padUnit(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initCountdown(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var el = scope.querySelector('[data-ci-countdown]');
    if (!el) return;
    var launch = parseInt(el.getAttribute('data-launch-at'), 10);
    if (!launch) return;

    var timer = null;

    function tick() {
      var diff = launch - Math.floor(Date.now() / 1000);
      if (diff <= 0) {
        clearInterval(timer);
        el.hidden = true;
        location.reload();
        return;
      }

      var map = {
        '[data-ci-countdown-days]': Math.floor(diff / 86400),
        '[data-ci-countdown-hours]': Math.floor((diff % 86400) / 3600),
        '[data-ci-countdown-minutes]': Math.floor((diff % 3600) / 60),
        '[data-ci-countdown-seconds]': diff % 60,
      };

      Object.keys(map).forEach(function (sel) {
        var node = el.querySelector(sel);
        if (node) node.textContent = padUnit(map[sel]);
      });
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initNotify(root) {
    var scope = root.closest('[data-ci-product]') || root || document;
    var trigger = scope.querySelector('[data-ci-notify-trigger]');
    var modal = document.querySelector('[data-ci-notify-modal]');
    if (!trigger || !modal) return;
    if (modal.dataset.ciNotifyReady === 'true') return;
    modal.dataset.ciNotifyReady = 'true';

    var form = modal.querySelector('[data-ci-notify-form]');
    var msgEl = modal.querySelector('[data-ci-notify-message]');
    var submitBtn = modal.querySelector('[data-ci-notify-submit]');
    var productNameEl = modal.querySelector('[data-ci-notify-product-name]');
    var defaultSubmitLabel = submitBtn ? submitBtn.textContent : 'Notify me!';

    function openModal() {
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('ci-notify-modal-open');
      if (productNameEl && trigger.getAttribute('data-product')) {
        productNameEl.textContent = trigger.getAttribute('data-product');
      }
      var firstInput = modal.querySelector('.ci-notify-modal__input');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('ci-notify-modal-open');
      modal.hidden = true;
      if (msgEl) {
        msgEl.hidden = true;
        msgEl.textContent = '';
        msgEl.classList.remove('is-error');
      }
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = defaultSubmitLabel;
      }
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    modal.querySelectorAll('[data-ci-notify-close]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var nameInput = form.querySelector('[name=name]');
      var emailInput = form.querySelector('[name=email]');
      var phoneInput = form.querySelector('[name=phone]');
      var productInput = form.querySelector('[name=product_id]');

      if (!nameInput.value.trim() || !emailInput.value.trim() || !phoneInput.value.trim()) {
        if (msgEl) {
          msgEl.hidden = false;
          msgEl.classList.add('is-error');
          msgEl.textContent = 'Please fill all fields.';
        }
        return;
      }

      var payload = {
        url_shopify: window.Shopify && Shopify.shop ? Shopify.shop : '',
        id_form: 2,
        ktp: 0,
        receipt_number: 0,
        product: productInput ? productInput.value : '',
        name: nameInput.value.trim(),
        email: emailInput.value.trim(),
        phone: phoneInput.value.trim(),
        ig: null,
        shoe_size: null,
        address: null,
        birtday: null,
      };

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Loading...';
      }
      if (msgEl) {
        msgEl.hidden = true;
        msgEl.classList.remove('is-error');
      }

      fetch('https://atmos-custom-plugin-front.devbdd.com/api/customers/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultSubmitLabel;
          }

          var result = data && data.response ? data.response : data;
          var status = result && (result.status || result.Status);

          if (String(status) === '200') {
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.classList.remove('is-error');
              msgEl.textContent = 'Thank you for your submit.';
            }
            setTimeout(closeModal, 1300);
          } else {
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.classList.add('is-error');
              msgEl.textContent = 'Already submitted';
            }
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultSubmitLabel;
          }
          if (msgEl) {
            msgEl.hidden = false;
            msgEl.classList.add('is-error');
            msgEl.textContent = 'Something wrong, try again.';
          }
        });
    });
  }

  function initSoldOutSync(root) {
    var scope = root.closest('[data-ci-product]') || root;
    var data = getProductData(scope);
    if (!data || !data.product) return;
    var form = scope.querySelector('[data-ci-product-form]');
    if (!form) return;

    form.querySelectorAll('.variant-ukuran').forEach(function (item) {
      var val = item.getAttribute('data-value');
      var hasAvailable = data.product.variants.some(function (v) {
        return v.title.toLowerCase().indexOf(val) !== -1 && v.available;
      });
      if (!hasAvailable) item.classList.add('soldout-variant');
    });
  }

  function initProductMinHeight(root) {
    var wrapper = root.querySelector('.Product__Wrapper');
    var info = root.querySelector('.Product__Info');
    if (!wrapper || !info) return;

    var calculateMinHeight = function () {
      if (window.innerWidth >= 1008) {
        var infoStyles = window.getComputedStyle(info);
        var paddingTop = parseInt(infoStyles.paddingTop, 10) || 0;
        var minHeight = info.scrollHeight - paddingTop;
        wrapper.style.minHeight = minHeight > 0 ? minHeight + 'px' : '';
      } else {
        wrapper.style.minHeight = '';
      }
    };

    calculateMinHeight();
    window.addEventListener('resize', calculateMinHeight);

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        calculateMinHeight();
      });
      resizeObserver.observe(info);
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.ciProductInit) return;
    root.dataset.ciProductInit = 'true';
    initGallery(root);
    initVariants(root);
    initQuantity(root);
    initAjaxAddToCart(root);
    initCountdown(root);
    initNotify(root);
    initSoldOutSync(root);
    initProductMinHeight(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ci-product]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
